import { EntityMerge } from '../IEntity';
import { APIEntity, registerEntity } from '../APIEntity';
import { IVisitor } from './visitor-types';
export type * from './visitor-types';

// `implements IVisitor` only checks the class; it contributes no members, so every
// field declared solely on IVisitor read as "does not exist". deepAssign populates
// them from the wire — this merge makes them part of the class type.
// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface Visitor extends EntityMerge<IVisitor> {}

@registerEntity
export class Visitor extends APIEntity<Visitor> implements IVisitor {
  ga_client_id?: string | null;
  utm_params?: Record<string, string> | null;
  visitor_roles?: string[];
  static type: string = 'visitor';

  constructor(entity: Partial<IVisitor> = {}) {
    super(entity);
    this.ga_client_id = entity.ga_client_id;
    this.utm_params = entity.utm_params;
    this.visitor_roles = entity.visitor_roles;
  }
}
